import React, { useEffect } from 'react';
import { Center } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { matchPath, Outlet, useNavigate } from 'react-router-dom';

import { useReduxDispatch } from '../../../app/store';
import { FeatureFlag, getFlagValue } from '../../../utils/common/feature-flag-helpers';
import { selectEvChargers } from '../../site/siteSlice';
import { selectEvChargerData, setSiteDeviceId } from './evChargerSlice';

/* istanbul ignore next -- @preserve */
export const EVChargerHome = () => {
  const evChargers = useSelector(selectEvChargers);
  const { hasVisitedRegisterScreen } = useSelector(selectEvChargerData);
  const hasEvChargers = !!evChargers?.length;
  const dispatch = useReduxDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getFlagValue(FeatureFlag.EnableEVSE)) {
      navigate('/sites/list', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (!hasEvChargers) return;

    const evChargerId = evChargers[0].id;
    if (evChargerId) dispatch(setSiteDeviceId(evChargerId.toString()));
  }, [dispatch, evChargers, hasEvChargers]);

  useEffect(() => {
    const isMatch = matchPath('/sites/:id/ev-charger/home', location.pathname);
    if (isMatch) {
      const path = !hasEvChargers && !hasVisitedRegisterScreen ? 'device-register' : 'device-status';
      navigate(path, { replace: true });
    }
  }, [hasEvChargers, hasVisitedRegisterScreen, navigate]);

  return (
    <Center flexDirection={'column'} height="100%">
      <Outlet />
    </Center>
  );
};
